// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --ion-background-color: #f6f1ef;
}

.sign-up-button {
  --background: var(--accent-color);
  --border-width: 1px;
  --border-style: none;
}
@media (min-width: 991px) {
  .sign-up-button {
    min-height: 64px;
    margin-bottom: 12px;
    font-size: 20px;
  }
}

ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-item {
  --border-width: 1px !important;
  --border-radius: 10px !important;
  --background: #353535;
  --border-bottom: none;
  border: none;
  padding-inline: 3%;
}
ion-item:not(:last-child) {
  margin-bottom: 12px;
}

@media (min-width: 991px) {
  ion-item.password {
    margin-bottom: 40px;
  }
}

.forgot-password {
  margin: 20px 0;
  cursor: pointer;
  text-align: center;
}
.forgot-password h4 {
  color: #fff !important;
  font-size: 16px;
  text-transform: uppercase;
  text-decoration: underline;
  font-family: AppFontMedium, sans-serif;
}

.wrapper {
  padding: 25px;
}
@media (max-width: 992px) {
  .wrapper {
    padding: 50px 7px 20px;
  }
}

.stacked {
  position: relative;
  top: -10px;
  left: 0%;
  z-index: 2;
  left: 3%;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

ion-label {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--color-black);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
@media (max-width: 992px) {
  ion-label {
    font-family: AppFontSemiBold;
    font-size: 14px;
  }
}

ion-label {
  color: #fff;
}

.main-button {
  margin-top: 40px;
  --border-color: var(--accent-color);
  color: #fff;
}
@media (min-width: 991px) {
  .main-button {
    margin-top: 0px;
    min-height: 64px;
    font-size: 20px;
    margin-bottom: 26px;
  }
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.button-wrapper ion-button {
  width: 100%;
  margin: 10px 0px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
@media (min-width: 991px) {
  .button-wrapper ion-button {
    min-height: 64px;
    font-size: 20px;
  }
  .button-wrapper ion-button:not(:last-child) {
    margin-bottom: 12px;
  }
}
.button-wrapper ion-button p {
  font-family: AppFontMedium, sans-serif;
  color: white;
  width: 75%;
}
@media (min-width: 991px) {
  .button-wrapper ion-button p {
    width: -moz-fit-content;
    width: fit-content;
  }
}
.button-wrapper ion-button ion-icon {
  margin-right: 10px;
  zoom: 0.9;
}
@media (min-width: 991px) {
  .button-wrapper ion-button ion-icon {
    margin-right: 10px;
    zoom: 1;
  }
}
.button-wrapper ion-button.google {
  --background: transparent;
}
.button-wrapper ion-button.google p {
  color: var(--color-black);
}
.button-wrapper ion-button.facebook {
  --background: #3b5997;
}
.button-wrapper ion-button.apple {
  --background: var(--color-black);
}

.wrapper-modal {
  max-width: 500px;
  margin: auto;
  height: 100%;
  position: relative;
  overflow: auto;
  overflow-x: hidden;
  background: var(--main-background);
}
.wrapper-modal ion-item {
  --background: #353535;
}
.wrapper-modal .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 25px;
  height: 25px;
  z-index: 99;
}
@media (min-width: 991px) {
  .wrapper-modal .close-icon {
    display: none;
  }
}
.wrapper-modal .big-close-icon {
  cursor: pointer;
  position: absolute;
  top: 15px;
  right: 15px;
  width: 50px;
  height: 50px;
  z-index: 99;
}
@media (max-width: 992px) {
  .wrapper-modal .big-close-icon {
    display: none;
  }
}
.wrapper-modal .title-text {
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFontMedium, sans-serif;
  font-size: 15px;
  letter-spacing: 0.08em;
  margin-bottom: 30px;
}
@media (min-width: 991px) {
  .wrapper-modal .title-text {
    font-family: AppFontBold, sans-serif;
    font-size: 32px;
    padding-top: 25px;
  }
}
.wrapper-modal .subtitle-text {
  width: 100%;
  text-align: center;
  color: var(--accent-color);
  text-transform: uppercase;
  font-family: AppFont, sans-serif;
  letter-spacing: 0.08em;
  text-wrap: balance;
  font-size: 12px;
  margin-bottom: 20px;
}
@media (min-width: 991px) {
  .wrapper-modal .subtitle-text {
    font-size: 20px;
    margin-bottom: 40px;
  }
}
.wrapper-modal .or {
  margin: 10px 0 30px;
}
.wrapper-modal .header-block {
  padding: 20px;
  border-bottom: 1px solid var(--accent-color);
}
@media (min-width: 991px) {
  .wrapper-modal .header-block {
    padding: 40px 40px 0px;
  }
}
.wrapper-modal .footer-block {
  padding: 20px;
}
@media (min-width: 991px) {
  .wrapper-modal .footer-block {
    padding: 20px 40px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/sign-in/sign-in.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,+BAAA;AADF;;AAIA;EACE,iCAAA;EACA,mBAAA;EACA,oBAAA;AADF;ACPE;EDKF;IAKI,gBAAA;IACA,mBAAA;IACA,eAAA;EACF;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,8BAAA;EACA,gCAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;AACF;AAEE;EACE,mBAAA;AAAJ;;AC9BE;EDmCF;IAEI,mBAAA;EAFF;AACF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAFF;AAIE;EACE,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,sCAAA;AAFJ;;AAMA;EAIE,aAAA;AANF;AC/CE;EDiDF;IAEI,sBAAA;EAAF;AACF;;AAIA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EAEA,QAAA;AAFF;;AAMA;EACE,eAAA;EACA,mBAAA;AAHF;;AAMA;EACE,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AAHF;ACzEE;EDuEF;IAQI,4BAAA;IACA,eAAA;EAFF;AACF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,gBAAA;EACA,mCAAA;EACA,WAAA;AADF;AC/FE;ED6FF;IAKI,eAAA;IACA,gBAAA;IACA,eAAA;IACA,mBAAA;EACF;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;AACF;AACE;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AACJ;ACrHE;ED+GA;IAQI,gBAAA;IACA,eAAA;EAEJ;EADI;IACE,mBAAA;EAGN;AACF;AAAI;EACE,sCAAA;EACA,YAAA;EACA,UAAA;AAEN;ACnIE;ED8HE;IAMI,uBAAA;IAAA,kBAAA;EAGN;AACF;AAAI;EACE,kBAAA;EACA,SAAA;AAEN;AC5IE;EDwIE;IAII,kBAAA;IACA,OAAA;EAIN;AACF;AADI;EACE,yBAAA;AAGN;AADM;EACE,yBAAA;AAGR;AACI;EACE,qBAAA;AACN;AAEI;EACE,gCAAA;AAAN;;AAKA;EAEE,gBAAA;EACA,YAAA;EAEA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,kCAAA;AAJF;AAME;EACE,qBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AALJ;ACnLE;EDkLA;IASI,aAAA;EAJJ;AACF;AAOE;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AALJ;AC3LE;EDyLA;IAUI,aAAA;EAJJ;AACF;AAOE;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;AALJ;AChNE;ED6MA;IAUI,oCAAA;IACA,eAAA;IAEA,iBAAA;EAJJ;AACF;AAOE;EACE,WAAA;EACA,kBAAA;EACA,0BAAA;EACA,yBAAA;EACA,gCAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AALJ;AClOE;ED8NA;IAYI,eAAA;IACA,mBAAA;EAJJ;AACF;AAOE;EACE,mBAAA;AALJ;AAQE;EACE,aAAA;EACA,4CAAA;AANJ;AC/OE;EDmPA;IAII,sBAAA;EAJJ;AACF;AAOE;EACE,aAAA;AALJ;ACvPE;ED2PA;IAGI,uBAAA;EAHJ;AACF","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n  --ion-background-color: #f6f1ef;\n}\n\n.sign-up-button {\n  --background: var(--accent-color);\n  --border-width: 1px;\n  --border-style: none;\n  @include desktop {\n    min-height: 64px;\n    margin-bottom: 12px;\n    font-size: 20px;\n  }\n}\n\nion-item.input-error {\n  margin-bottom: 8px !important;\n}\n\nion-item {\n  --border-width: 1px !important;\n  --border-radius: 10px !important;\n  --background: #353535;\n  --border-bottom: none;\n  border: none;\n  padding-inline: 3%;\n\n\n  &:not(:last-child) {\n    margin-bottom: 12px;\n  }\n\n}\n\nion-item.password {\n  @include desktop {\n    margin-bottom: 40px;\n  }\n}\n\n.forgot-password {\n  margin: 20px 0;\n  cursor: pointer;\n  text-align: center;\n\n  h4{\n    color: #fff !important;\n    font-size: 16px;\n    text-transform: uppercase;\n    text-decoration: underline;\n    font-family: AppFontMedium, sans-serif;\n  }\n}\n\n.wrapper {\n  @include mobile {\n    padding: 50px 7px 20px;\n  }\n  padding: 25px;\n}\n\n.stacked {\n  position: relative;\n  top: -10px;\n  left: 0%;\n  z-index: 2;\n\n  left: 3%;\n\n}\n\nion-note {\n  font-size: 12px;\n  padding-right: 10px;\n}\n\nion-label {\n  font-family: AppFontBold, sans-serif;\n  font-size: 16px;\n  color: var(--color-black);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n\n  @include mobile {\n    font-family: AppFontSemiBold;\n    font-size: 14px;\n  }\n}\nion-label {\n  color: #fff;\n}\n\n.main-button {\n  margin-top: 40px;\n  --border-color: var(--accent-color);\n  color: #fff;\n  @include desktop {\n    margin-top: 0px;\n    min-height: 64px;\n    font-size: 20px;\n    margin-bottom: 26px;\n  }\n}\n\n.button-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n\n  ion-button {\n    width: 100%;\n    margin: 10px 0px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n\n    @include desktop {\n      min-height: 64px;\n      font-size: 20px;\n      &:not(:last-child) {\n        margin-bottom: 12px;\n      }\n    }\n\n    p {\n      font-family: AppFontMedium, sans-serif;\n      color: white;\n      width: 75%;\n\n      @include desktop {\n        width: fit-content;\n      }\n    }\n\n    ion-icon {\n      margin-right: 10px;\n      zoom: 0.9;\n      @include desktop {\n        margin-right: 10px;\n        zoom: 1;\n      }\n    }\n\n    &.google {\n      --background: transparent;\n\n      p {\n        color: var(--color-black);\n      }\n    }\n\n    &.facebook {\n      --background: #3b5997;\n    }\n\n    &.apple {\n      --background: var(--color-black);\n    }\n  }\n}\n\n.wrapper-modal {\n\n  max-width: 500px;\n  margin: auto;\n\n  height: 100%;\n  position: relative;\n  overflow: auto;\n  overflow-x: hidden;\n  background: var(--main-background);\n\n  ion-item {\n    --background: #353535;\n  }\n\n  .close-icon {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    width: 25px;\n    height: 25px;\n    z-index: 99;\n\n    @include desktop {\n      display: none;\n    }\n  }\n\n  .big-close-icon {\n    cursor: pointer;\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    width: 50px;\n    height: 50px;\n    z-index: 99;\n\n    @include mobile {\n      display: none;\n    }\n  }\n\n  .title-text {\n    width: 100%;\n    text-align: center;\n    color: var(--color-black);\n    text-transform: uppercase;\n    font-family: AppFontMedium, sans-serif;\n    font-size: 15px;\n    letter-spacing: 0.08em;\n    margin-bottom: 30px;\n    @include desktop {\n      font-family: AppFontBold, sans-serif;\n      font-size: 32px;\n\n      padding-top: 25px;\n    }\n  }\n\n  .subtitle-text {\n    width: 100%;\n    text-align: center;\n    color: var(--accent-color);\n    text-transform: uppercase;\n    font-family: AppFont, sans-serif;\n    letter-spacing: 0.08em;\n    text-wrap: balance;\n    font-size: 12px;\n    margin-bottom: 20px;\n\n    @include desktop {\n      font-size: 20px;\n      margin-bottom: 40px;\n    }\n  }\n\n  .or {\n    margin: 10px 0 30px;\n  }\n\n  .header-block {\n    padding: 20px;\n    border-bottom: 1px solid var(--accent-color);\n    @include desktop {\n      padding: 40px 40px 0px;\n    }\n  }\n\n  .footer-block {\n    padding: 20px;\n    @include desktop {\n      padding: 20px 40px 20px;\n    }\n  }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
